<template>
    <div class="flex flex-col justify-center md:flex-row gap-2 py-2 mt-auto">
        <div class="links-footer flex justify-center gap-4">
            <a :href="$root.app.terms_of_use_url" class="text-gray-400 no-underline">Terms of Use</a>
            <a :href="$root.app.privacy_policy_url" class="text-gray-400 no-underline">Privacy Policy</a>
            <a :href="$root.app.contact_us_url" class="text-gray-400 no-underline">Need Help?</a>
        </div>

        <div class="copyright">
            <p data-testid="copyright" class="text-gray-400 text-center">
                © {{ currentYear() }} {{ $root.app.company_name }}. All Rights Reserved
            </p>
        </div>
    </div>
</template>

<script>

import Moment from 'moment';

export default {
    data() {
        return {
            
        }
    },
    methods: {
        currentYear() {
            return Moment().year();
        }
    }
}

</script>